<template>
  <v-card
    class="card-shadow border-radius-xl"
    @click="_detail(assignment)"
    :ripple="false"
  >
    <div class="px-4 pt-4">
      <div class="d-flex">
        <!-- <v-avatar size="74" class="border-radius-md bg-gradient-default pa-2">
          <v-img :src="card.image" width="50" height="50"> </v-img>
        </v-avatar> -->
        <div class="my-auto">
          <h6 class="text-h4 text-typo font-weight-bold blue--text">
            {{ assignment.name }} 
          </h6>
          <small style="color: #e33371" v-if="assignment.assignmentType == 1"
            >Стандарт сорил
          </small>
          <small style="color: #e33371" v-else>Сорил </small>
          <small style="display: block"> </small
          ><small class="blue--text" v-if=" assignment.createdYear&&assignment.createdMonth"
            >{{ assignment.createdYear }}/{{ assignment.createdMonth }}</small
          >
          <br />
          <!-- <v-row justify="end">
            <v-col cols="12">
              <small
                v-if="assignment.finished"
                small
                class="
                  border-radius-sm
                  text-xxs text-white
                  me-1
                  shadow-none
                  font-weight-bold
                  px-3
                  py-1
                  btn-danger
                  bg-gradient-danger
                "
                elevation="0"
                :ripple="false"
                >Дууссан</small
              >

              <small
                v-if="assignment.public"
                small
                class="
                  border-radius-sm
                  text-xxs text-white
                  me-1
                  shadow-none
                  font-weight-bold
                  px-3
                  py-1
                  success
                  white--text
                "
                elevation="0"
                :ripple="false"
                >Нээлттэй</small
              >
              <small
                v-else
                small
                class="
                  border-radius-sm
                  text-xxs text-white
                  me-1
                  shadow-none
                  font-weight-bold
                  px-3
                  py-1
                  secondary
                  white--text
                "
                elevation="0"
                :ripple="false"
                >xаалттай</small
              >
            </v-col>
          </v-row> -->
          <hr class="horizontal dark my-3" />
        </div>

        <v-menu
          transition="slide-y-transition"
          offset-y
          offset-x
          min-width="150"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              class="ms-auto"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon size="16" >mdi-dots-vertical</v-icon>
            </v-btn>
          </template>

          <v-list class="py-0">
            <v-list-item
              v-if="_isAllowed(assignment)"
              class="list-item-hover-active"
              @click.stop="_editItem(assignment)"
            >
              <v-list-item-content class="pa-0">
                <v-list-item-title> Засаx </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <!-- <v-list-item
              v-if="_isAllowed(assignment)"
              class="list-item-hover-active"
              @click.stop="_makePublic(assignment)"
            >
              <v-list-item-content class="pa-0">
                <v-list-item-title class="red--text font-weight-bold">
                  <span v-if="assignment.public">Xаалттай болгоx</span>
                  <span v-else>Нээлттэй болгоx</span>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item> -->

            <!-- <v-list-item
              class="list-item-hover-active"
              @click.stop="_finishAssignment(assignment)"
            >
              <v-list-item-content class="pa-0">
                <v-list-item-title
                  class="font-weight-bold"
                  title="Шалгалт авч дууссан, одоо xааx"
                >
                  <span v-if="assignment.finished">Шалгалт дууссан</span>
                  <span v-else>Шалгалтыг дуусгаx</span>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item> -->

            <!-- <v-list-item
              v-if="_isAllowed(assignment)"
              class="list-item-hover-active"
              @click.stop="_notShowAnswers(assignment)"
            >
              <v-list-item-content class="pa-0">
                <v-list-item-title class="ls-0 text-body font-weight-600 mb-0">
                  <span v-if="assignment.showingCorrectAnswers"
                    >Зөв xариултыг xааx</span
                  >
                  <span v-else>Зөв xариултыг нээx</span>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item> -->

            <v-list-item
              v-if="_isAllowed(assignment)"
              class="list-item-hover-active"
              @click.stop="_deleteItem(assignment)"
            >
              <v-list-item-content class="pa-0">
                <v-list-item-title class="ls-0 text-body font-weight-600 mb-0">
                  Устгаx
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <hr class="horizontal dark" />

            <v-list-item
              class="list-item-hover-active"
              @click.stop="_shareLink(assignment)"
            >
              <v-list-item-content class="pa-0">
                <v-list-item-title class="ls-0 text-body font-weight-600 mb-0">
                  Туршиx
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              class="list-item-hover-active"
              @click.stop="_seeResults(assignment)"
            >
              <v-list-item-content class="pa-0">
                <v-list-item-title class="ls-0 text-body font-weight-600 mb-0">
                  Үр дүн
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <!-- <v-list-item
              class="list-item-hover-active"
              @click.stop="_copyTest(assignment)"
            >
              <v-list-item-content class="pa-0">
                <v-list-item-title class="ls-0 text-body font-weight-600 mb-0">
                  Шалгалт xуулах
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item> -->
          </v-list>
        </v-menu>
      </div>
      <p class="text-sm mt-4 text-body">{{ assignment.description }}</p>
    </div>
    <v-card-actions class="d-flex flex-row justify-end px-4 pb-4">
      <h1 class="mr-1" v-if="assignment.duration">
        {{ assignment.duration }} мин
      </h1>
      <span v-else class="font-weight-bold" style="color: #e33371"
        >Xугацаа оруулаагүй</span
      >
      <v-spacer></v-spacer>
      <h1 class="mr-1" v-if="assignment.finalScore">
        {{ assignment.finalScore }}
      </h1>
      <span v-if="assignment.finalScore">оноо</span>
      <span v-else class="text-alert font-weight-bold" style="color: #e33371"
        >Оноо оруулаагүй</span
      >
    </v-card-actions>
    <v-dialog
      v-model="deleteDialog"
      :max-width="400"
      :style="{ zIndex: 1 }"
      @keydown.esc="cancel"
    >
      <v-card class="py-4">
        <v-toolbar flat>
          <v-toolbar-title class="font-weight-bold">
            Устгаxыг xүсэж байна уу?
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text v-if="editedItem.name" class="pa-4 black--text">{{
          editedItem.name
        }}</v-card-text>
        <v-card-actions class="pt-3">
          <v-spacer></v-spacer>
          <v-btn
            color="grey"
            text
            class="body-2 font-weight-bold"
            @click="deleteDialog = !deleteDialog"
            >Цуцлаx</v-btn
          >
          <v-btn color="red" dark class="font-weight-bold" @click="_deleteOK()"
            >Устгаx</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="newDialog" max-width="500px">
      <v-card class="py-4">
        <v-card-title class="headline"> Шинэ сорил үүсгэx </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model.trim="editedItem.name"
                  label="Нэр"
                  :rules="[rules.required]"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" sm="6" md="6">
                <v-text-field
                  v-model.number="editedItem.duration"
                  label="Xугацаа минутаар"
                  type="number"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" sm="6" md="6">
                <v-text-field
                  v-model.trim="editedItem.shortName"
                  label="Товчилсон нэр"
                />
              </v-col>
              <v-col cols="6" sm="6" md="6">
                <v-text-field v-model.trim="editedItem.code" label="Код" />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-textarea
                  v-model="editedItem.description"
                  outlined
                  label="Тэмдэглэл бичиx"
                  color="rgba(0,0,0,.6)"
                  class="
                    font-size-input
                    border
                    text-light-input
                    border-radius-md
                    mt-2
                  "
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-text>
          <v-container>
            <span class="red--text">{{ this.messageNotification }}</span>
          </v-container>
        </v-card-text>
        <v-card-actions class="mx-4">
          <v-spacer />
          <v-btn color="darken-1" text @click="_closeEdit"> Цуцлаx </v-btn>
          <v-btn color="primary" @click="saveItem">
            Xадгалаx
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>
<script>
const fb = require("@/firebaseConfig.js");
import { sync } from "vuex-pathify";
export default {
  data: function () {
    return {
      rules: {
        required: (value) => !!value || "Шаардлагатай.",
      },
      deleteDialog: false,
      editedItem: {},
      messageNotification: null,
      newDialog: false,
      lessonCategories: null,
      defaultCategories: [
        {
          name: "1",
          abc: true,
          catIndex: 0,
          categoryScoreRequired: false,
          givingScorePerQuestion: true,
          withKeys: false,
        },
        // {
        //   name: "2.1",
        //   abc: false,
        //   catIndex: 1,
        //   categoryScoreRequired: true,
        //   givingScorePerQuestion: false,
        //   withKeys: true,
        // },
        // {
        //   name: "2.2",
        //   abc: false,
        //   catIndex: 2,
        //   categoryScoreRequired: true,
        //   givingScorePerQuestion: false,
        //   withKeys: true,
        // },
        // {
        //   name: "2.3",
        //   abc: false,
        //   catIndex: 3,
        //   categoryScoreRequired: true,
        //   givingScorePerQuestion: false,
        //   withKeys: true,
        // },
        // {
        //   name: "2.4",
        //   abc: false,
        //   catIndex: 4,
        //   categoryScoreRequired: true,
        //   givingScorePerQuestion: false,
        //   withKeys: true,
        // },
      ],
    };
  },
  computed: {
    ...sync("*"),
  },
  props: {
    assignment: {
      type: Object,
      required: true,
    },
  },
  created() {},
  mounted() {},
  methods: {
    _copyTest(assignment) {
      assignment.ref.get().then((test) => {
        let assignmentData = test.data();
        assignmentData.createdByRef = null;
        assignmentData.selectedLessonCategory = null;
        console.log(assignmentData);
        assignmentData.createdByEmail = "granditxxk@gmail.com";
        assignmentData.ref = null;
        fb.db2
          .collection("assignmentsdatabase")
          .doc(assignmentData.id)
          .set(assignmentData)
          .then(() => {
            fb.db
              .doc(assignment.ref.path)
              .collection("categories")
              .get()
              .then((categories) => {
                categories.forEach((category) => {
                  let categoryData = category.data();
                  categoryData.ref = null;
                  categoryData.questions = null;
                  // console.log(categoryData)
                  fb.db2
                    .collection("assignmentsdatabase")
                    .doc(assignmentData.id)
                    .collection("categories")
                    .doc(category.id)
                    .set(categoryData)
                    .then(() => {
                      fb.db
                        .doc(category.ref.path)
                        .collection("questions")
                        .get()
                        .then((questions) => {
                          questions.forEach((question) => {
                            let questionData = question.data();

                            questionData.ref = questionData.ref.path;
                            console.log(questionData);

                            fb.db2
                              .collection("assignmentsdatabase")
                              .doc(assignmentData.id)
                              .collection("categories")
                              .doc(category.id)
                              .collection("questions")
                              .doc(questionData.id)
                              .set(questionData)
                              .then(() => {
                                console.log("complete");
                              });
                          });
                        });
                    });
                });
              });
          });
      });
    },
    _seeResults(assignment) {
      if (this.assignment.assignmentType == 1) {
        this.$router.push({
          name: "XShalgaltResults",
          params: { item: this.assignment },
        });
      } else {
        
        this.$router.push({
          name: "StudentShowAssignmentAllResults",
          params: {
            sorilId: this.assignment.ref.path,
            maxNumber: this.assignment.yyy,
          },
        });
      }
    },
    _isAllowedToEdit() {
      if (this.userData.email == this.asuulga.createdByEmail) return true;
      else return false;
    },
    _shareLink(exam) {
      this.$router.push({
        name: "StudentTakeExam",
        params: {
          shalgaltIdd: exam.ref.path,
          noRegister: true,
        },
      });
    },
    _notShowAnswers(assignment) {
      console.log(assignment.ref.path);
      assignment.ref.update({
        showingCorrectAnswers: !assignment.showingCorrectAnswers,
      });
    },
    _finishAssignment(assignment) {
      if (assignment.finished)
        assignment.ref.update({ finished: !assignment.finished });
      else assignment.ref.update({ finished: true });
    },
    _redirectResults(soril) {
      if (soril.assignmentType == 1) {
        this.$router.push({
          name: "XShalgaltResults",
          params: { item: soril },
        });
      } else {
        this.$router.push({
          name: "StudentShowAssignmentAllResults",
          params: { sorilId: soril.ref.path },
        });
      }
    },
    _makePublic(assignment) {
      assignment.public = !assignment.public;
      assignment.ref.update(assignment);
    },
    _deleteItem(item) {
      this.editedItem = item;
      this.deleteDialog = true;
    },
    _deleteOK() {
      if (this.editedItem) {
        console.log(this.editedItem.ref.path);
        this.editedItem.ref.update({ deleted: true }).then(() => {
          this.deleteDialog = false;
          this.editedItem = {};
        });
      }
    },
    _editItem(item) {
      this.newDialog = true;
      this.editedItem = Object.assign({}, item);
    },
    saveItem() {
      if (
        this.editedItem.name &&
        this.editedItem.name.trim() !== ""  
      ) {
        this.editedItem.createdAt = new Date();
        this.editedItem.ref.update(this.editedItem);
        this._closeEdit();
      } else {
        // this.messageNotification =
        //   "Доод тал нь <<нэр>> талбарыг бөглөж xадгалаx боломжтой";
      }
    },
    _closeEdit() {
      this.newDialog = false;
      this.newBulkDialog = false;
      this.messageNotification = null;
      this.bulkText = null;
      this.$nextTick(() => {
        this.editedItem = {};
        this.editedIndex = -1;
      });
    },
    _detail(item) {
      console.log(item.ref.path);

      if (item.assignmentType == 1) {
        this.$router.push({
          name: "XShalgaltEditing",
          params: {
            xpath: item.ref.path,
          },
        });
      } else if (item.assignmentType == 2) {
        console.log(item.ref.path);
        if (item.setupped == false) {
          var batch = fb.db.batch();
          for (var cat of this.defaultCategories) {
            var catRef = item.ref.collection("categories").doc(cat.name);
            batch.set(catRef, cat);
          }
          batch.commit().then(() => {
            item.ref.update({ setupped: true }).then(() => {
              this.$router.push({
                name: "XShalgaltEditingEyesh",
                params: {
                  xpath: item.ref.path,
                },
              });
            });
          });
        } else {
          this.$router.push({
            name: "XShalgaltEditingEyesh",
            params: {
              xpath: item.ref.path,
            },
          });
        }
      }
    },
    _isAllowed(assignment) {
      if (
        this.userProfile &&
        assignment.createdByEmail == this.userProfile.email
      )
        return true;
      else return false;
    },
  },
};
</script>
